export default __webpack_public_path__ + "static/media/cloud-practitioner.c6532458.png";